import { MessagesPanel } from "@/components/MessagesPanel";

export default function CoachMessages() {
  return (
    <div className="space-y-8" data-testid="coach-messages">
      <header>
        <div className="overline">Inbox</div>
        <h1 className="font-serif text-5xl mt-3">Messages</h1>
      </header>
      <MessagesPanel testid="coach-msg-panel" />
    </div>
  );
}
